import React from 'react'
import { useTranslation } from 'react-i18next'
import { WanderingStatus } from '@/util/location'

interface IProps {
    value?: WanderingStatus
}

const WanderingStatusBadge: React.FC<IProps> = ({ value }) => {
    const { t } = useTranslation()

    const getStyle = () => {
        switch (value) {
            case WanderingStatus.WANDERING:
                return 'bg-sub_r text-white'
            case WanderingStatus.SAFE:
                return 'bg-main_b text-white'
            case WanderingStatus.UNKNOWN:
            default:
                return 'bg-gray4 text-white'
        }
    }

    const getIcon = () => {
        switch (value) {
            case WanderingStatus.WANDERING:
                return (
                    <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                )
            case WanderingStatus.SAFE:
                return (
                    <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                )
            case WanderingStatus.UNKNOWN:
            default:
                return (
                    <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                )
        }
    }

    const getText = () => {
        switch (value) {
            case WanderingStatus.WANDERING:
                return t('wandering.status.wandering')
            case WanderingStatus.SAFE:
                return t('wandering.status.safe')
            case WanderingStatus.UNKNOWN:
            default:
                return t('wandering.status.unknown')
        }
    }

    return (
        <div className={`flex items-center gap-[5px] px-[8px] py-[4px] rounded-[4px] ${getStyle()}`}>
            {getIcon()}
            <span className="text-[12px] font-medium">{getText()}</span>
        </div>
    )
}

export default WanderingStatusBadge
